import s from "./ProgressDots.module.css";

export interface ProgressDotsProps {
  total: number;
  current: number;
  label: string;
  className?: string;
}

/**
 * One segment per question, filling cumulatively. Carries the real progress
 * as text for assistive tech — the bar itself is decorative, and a row of
 * eight divs announces nothing useful on its own.
 */
export function ProgressDots({ total, current, label, className }: ProgressDotsProps) {
  return (
    <div
      className={className ? `${s.root} ${className}` : s.root}
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={current + 1}
      aria-valuetext={label}
    >
      {Array.from({ length: total }, (_, i) => (
        <span key={i} className={i <= current ? `${s.dot} ${s.done}` : s.dot} />
      ))}
    </div>
  );
}
